import { stringToDate } from '@hc-frontend/utils'

export default function formatMonth(input: string | Date) {
  let date: Date | undefined

  if (typeof input === 'string') {
    try {
      date = stringToDate(input)
    } catch (error) {
      console.error('Invalid date format:', input, error)
      return '' // Return an empty string if the date is invalid
    }
  } else if (input instanceof Date) {
    date = input
  }

  if (!date) {
    console.error('Date conversion failed for:', dateString)
    return '' // Return an empty string if the date conversion fails
  }

  const startParts = date.toDateString().split(' ')
  return `${startParts[1]} ${+startParts[2]}, ${startParts[3]}`
}
